import React from "react";

/**
 * Academic tool page header — back control on the left, title center-left, actions on the right.
 */
function TeacherAcademicHeader({
  title,
  subtitle,
  backLabel = "Back",
  onBack,
  actions,
}) {
  return (
    <div className="tp-academic-top">
      {onBack ? (
        <button type="button" className="tp-back-btn" onClick={onBack}>
          <span aria-hidden="true">←</span>
          <span>{backLabel}</span>
        </button>
      ) : (
        <span className="tp-academic-top__spacer" />
      )}
      <div className="tp-academic-top__title">
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div className="tp-academic-top__actions">{actions}</div> : null}
    </div>
  );
}

export default TeacherAcademicHeader;
